import { deviceType } from '@/utils/deviceType'

// 判断是否是Android操作系统
export function isAndroid(ua) {
  if (!ua) return false
  const s = ua.toLowerCase()
  return (
    s.includes('linux') ||
    s.includes('android') ||
    s.includes('adr') ||
    s.includes('okhttp')
  )
}

// 判断是否是iOS操作系统
export function isIOS(ua) {
  if (!ua) return false
  const s = ua.toLowerCase()
  return (
    s.includes('darwin') ||
    s.includes('iphone') ||
    s.includes('ipad') ||
    s.includes('ipod') ||
    s.includes('macintosh') ||
    s.includes('cfnetwork')
  )
}

// 获取客户端类型
export function getPlatformTypeByUserAgent(ua) {
  // if (isIOS(ua)) return 0
  // if (isAndroid(ua)) return 1
  return 3 // 后台
}

const uaParser = require('ua-parser-js')

// 获取操作系统类型
export function getOs(ua) {
  if (!ua) return ''
  const os = uaParser(ua).os
  return `${os.name} ${os.version}`
}

// 获取当前userAgent浏览器名称
export const getBrowserName = userAgent => {
  if (!userAgent) return ''
  let compare = function(s) {
      return userAgent.indexOf(s) >= 0
    },
    ie11 = (function() {
      return (
        userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
      )
    })()
  if (compare('MSIE') || ie11) {
    return 'ie'
  } else if (compare('Firefox') && !ie11) {
    return 'Firefox'
  } else if (compare('Chrome') && !ie11) {
    if (userAgent.indexOf('Edge') > -1) {
      return 'Edge'
    } else {
      const regStr_saf = /chrome\/([\d.]+)/
      const Chrome = userAgent.toLowerCase().match(regStr_saf)
      const version = (Chrome && Chrome[1]) || ''
      return 'Chrome/' + version
    }
  } else if (compare('Opera') && !ie11) {
    return 'Opera'
  } else if (compare('Safari') && !ie11) {
    const regStr_saf = /version\/([\d.]+).*safari/
    const Safari = userAgent.toLowerCase().match(regStr_saf)
    const version = (Safari && Safari[1]) || ''
    // Safari浏览器版本小于10返回错误ie页面
    if (parseInt(version) < 10) {
      return 'ie'
    } else {
      return 'Safari/' + version
    }
  }
}

// 获取当前是否是非pc浏览
export const isMobile = () => {
  // 1通过屏幕尺寸判断
  // const app = document.getElementById('app')
  // const mediaWidth = app.clientWidth
  // return mediaWidth <= 750
  // 2通过终端类型判断
  const userAgent = navigator.userAgent
  const deviceType_ = deviceType(userAgent)
  return deviceType_.type !== 'pc'
}
